import Select from "react-select";
import React, {useContext, useEffect, useState} from "react";
import axiosConfig from "../../../Config/axios";
import AuthorizationContext from "../../../_helper/Authorization";
import {AuthorizationContextType} from "../../../_helper/Authorization/AuthorizationTypes";

interface commonSelectorProps {
    url: string;
    options: any;
    register: any;
    name: string;
    value: any;
    idColumn?: string;
    nameColumn?: string | undefined;
    params?: any;
    onChange?: (event: any) => void;
}

const CommonSelector = ({
                            url,
                            idColumn = 'id',
                            nameColumn = 'name',
                            register,
                            options,
                            name,
                            value,
                            params,
                            onChange
                        }: commonSelectorProps) => {

    const [dropDownOptions, setDropDownOptions] = useState<any[]>([]);
    const [selectedDropDownOptions, setSelectedDropDownOptions] = useState<any>({});
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    useEffect(() => {
        setLoaderVisibility(true);
        const config = {
            params: params
        };
        axiosConfig
            .get(url, config)
            .then((response: { data: { data: any; }; }) => {
                const responseData = response?.data?.data;
                const dropDownData = Array.isArray(responseData) ? responseData : responseData?.data;

                if (Array.isArray(dropDownData)) {
                    setDropDownOptions(dropDownData.map((data: { [x: string]: any; }) => ({
                        value: data[idColumn],
                        label: data[nameColumn],
                        key: data.key,
                        payload: data,
                    })));
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }, [])

    const onChangeMethod = (value: any) => {
        register(name, value);
        setSelectedDropDownOptions(value);
        onChange && onChange(value);
    }

    useEffect(() => {
        value && setSelectedValue(value);
    }, [value, dropDownOptions])

    const setSelectedValue = (selectedValue: any) => {
        const selectedValueArray = dropDownOptions.filter((option) => option.value === selectedValue);
        selectedValueArray.length && setSelectedDropDownOptions(selectedValueArray[0]);
    }

    return (
        <Select
            value={selectedDropDownOptions}
            isLoading={loaderVisibility}
            options={dropDownOptions}
            onChange={onChangeMethod}
            className="js-example-basic-single col-sm-12" {...options}/>
    )
}
export default CommonSelector;